import React from 'react'
import { UserService } from '@duck/api-definitions'
import { RelativeDateTime } from '../../datetime/RelativeDateTime'
import { useTar } from '@/modules'
import { CopyableId } from '@duck/ui'

interface AssignmentsSectionProps {
  assignments: UserService.AdminUserAssignment[]
}

const STATUS_COLORS: Record<string, string> = {
  active: 'bg-success/10 text-success',
  inactive: 'bg-muted/10 text-muted-foreground',
  sent: 'bg-blue-500/10 text-blue-600',
  draft: 'bg-muted/10 text-muted-foreground',
}

export const AssignmentsSection: React.FC<AssignmentsSectionProps> = ({ assignments }) => {
  const { t } = useTar()

  if (assignments.length === 0) {
    return (
      <div className="text-center py-8 text-muted-foreground text-sm">
        {t('partner.noAssignments')}
      </div>
    )
  }

  return (
    <div className="overflow-x-auto">
      <table className="w-full text-sm">
        <thead>
          <tr className="border-b border-border text-muted-foreground">
            <th className="text-start py-2 px-3 font-medium">{t('common.id')}</th>
            <th className="text-start py-2 px-3 font-medium">{t('common.organization')}</th>
            <th className="text-start py-2 px-3 font-medium">{t('common.status')}</th>
            <th className="text-start py-2 px-3 font-medium">{t('common.startDate')}</th>
            <th className="text-start py-2 px-3 font-medium">{t('partner.dueDate')}</th>
            <th className="text-start py-2 px-3 font-medium">{t('common.createdAt')}</th>
          </tr>
        </thead>
        <tbody>
          {assignments.map((a) => (
            <tr key={a.assignmentId} className="border-b border-border/50 hover:bg-muted/5">
              <td className="py-2">
                <CopyableId value={a.assignmentId} />
              </td>
              <td className="py-2 px-3 ps-0">{a.organizationName || a.organizationId}</td>
              <td className="py-2 px-3">
                <span className={`inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium ${STATUS_COLORS[a.status] || 'bg-muted/10 text-muted-foreground'}`}>
                  {a.status}
                </span>
              </td>
              <td className="py-2 px-3">
                {a.startDate ? <RelativeDateTime isoDateString={a.startDate} /> : '-'}
              </td>
              <td className="py-2 px-3">
                {a.dueDate ? <RelativeDateTime isoDateString={a.dueDate} /> : '-'}
              </td>
              <td className="py-2 px-3">
                {a.createdAt ? <RelativeDateTime isoDateString={a.createdAt} /> : '-'}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  )
}
